module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"update-template":"Update Template","template-updated":"Template updated","failed-update-template":"Failed to update template","failed-retrieve-template":"Failed to retrieve template","create-template":"Create Template","template-created":"Template created","failed-create-template":"Failed to create template","template":"Template","type":"Type","subject":"Subject"}}')
  delete Component.options._Ctor
}
